import { handleDirectPurchase } from '@wix/wixstores-client-storefront-sdk/dist/src/viewer-script/wixcode/checkout/handleDirectPurchase';
import { getCheckoutUrl } from './getCheckoutUrl';
import { EcomPlatformViewerScriptContext } from '../../viewer-script/types';
import { PageMap } from '@wix/wixstores-client-core';
import { EcomPlatformViewerScriptContext as SdkEcomPlatformViewerScriptContext } from '@wix/wixstores-client-storefront-sdk';

export const createCheckoutPublicApi = ({
  context,
  origin: legacyOrigin,
}: {
  context: EcomPlatformViewerScriptContext;
  origin: string;
}) => ({
  handleDirectPurchase: handleDirectPurchase({
    context: context as unknown as SdkEcomPlatformViewerScriptContext,
    origin: legacyOrigin,
  }),
  getCheckoutUrl: getCheckoutUrl({ context }),
  preloadCheckoutPage: async () => {
    try {
      const sectionUrl = await context.siteStore.getSectionUrl(
        PageMap.CHECKOUT,
      );
      if (sectionUrl.relativeUrl) {
        context.siteStore.siteApis.prefetchPageResources({
          pages: [sectionUrl.relativeUrl],
        });
      }
    } catch (e) {
      console.error('failed to prefetch checkout page', e);
    }
  },
});
